export default "__VITE_ASSET__b961b5fc__"